import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const steps = [
  "Customer Info",
  "Occupation & Dependants",
  "Medical History",
];

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
  wizard?: boolean | string;
  expense?: string;
}

export function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, wizard, expense, ...other } = props;
  const theme = useTheme();
  const background = wizard ? theme.palette.primary.light : expense || theme.palette.background.paper;
  const foreground = wizard || expense ? theme.palette.getContrastText(background) : theme.palette.text.primary;

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        pr: 8,
        position: "relative",
        overflowWrap: "anywhere",
        borderBottom: 1,
        borderColor: "divider",
        backgroundColor: background,
        color: foreground,
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: foreground,
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export interface IActiveData {
  index: number;
  stepComponent: JSX.Element;
}
